import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_CHANGE_PERSON_REQUEST_LIST_ID");

const expand =
  "expand=fields(select=Title, eDescription,eIssueNumber,eIssueTimes,eIssueEffectiveDate, eCourse, eMajor, eCourseDate, eCourseDateEnd, eContent, eTrainingType, eFileContent, eDeptHeadComment, eITLeadComment, eITHeadComment, eAssigneeComment, eApprovalComment, eApprovedBy, eApprovedDate,eApprovedStatus, eApprovedByITLead,eApprovedByITLeadStatus, eApprovedByITLeadDate,eApprovedByITHead ,eApprovedByITHeadStatus, eApprovedByITHeadDate, eAssignee, eAssigneeStatus, eAssigneeStatusDate, eRequestStatus, eRequestType, eSoftwareId, eDepartment, eDepartmentID, eUnit, ePhoneNumber, eComments)";
export class HOChangePersonRequestService {
  static async getChangePersonRequests(email: string, status?: string) {
    if (
      email.toLowerCase() === "thiennv@viags.vn" ||
      email.toLowerCase() === "namdh@viags.vn" ||
      email.toLowerCase() === "trungdt@viags.vn" ||
      email.toLowerCase() === "hieppt@viags.vn" ||
      email.toLowerCase() === "botit@viags.vn" ||
      email.toLowerCase() === "tienhc@viags.vn" ||
      email.toLowerCase() === "huyth@viags.vn" ||
      email.toLowerCase() === "datnt@viags.vn" ||
      email.toLowerCase() === "sonnhong@viags.vn" ||
      email.toLowerCase() === "taidv@viags.vn" ||
      email.toLowerCase() === "thuonghh@viags.vn" ||
      email.toLowerCase() === "luubd@viags.vn" ||
      email.toLowerCase() === "nghitc@viags.vn" ||
      email.toLowerCase() === "phuocvd@viags.vn"
    ) {
      return api
        .get(
          getURL(
            `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`
          )
        )
        .then((res) => {
          return res.data.value.reverse();
        })
        .catch((err) => {
          throw new RequestError(err);
        });
    } else {
      let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
      return api
        .get(
          getURL(
            `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`
          )
        )
        .then((res) => {
          return res.data.value.reverse();
        })
        .catch((err) => {
          throw new RequestError(err);
        });
    }
  }

  static async getMyChangePersonRequests(email: string) {
    return api
      .get(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`)
      )
      .then((res) => {
        return res?.data.value
          .filter(
            (request: any) =>
              request.createdBy.user.email.toLowerCase().split("@")[0] ===
              email.toLowerCase().split("@")[0]
          )
          .reverse();
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getDetailsChangePersonRequest(id: any) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async addChangePersonRequest(leaveRequest: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), leaveRequest)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async updateChangePersonRequest(id: any, fields: any) {
    return api
      .patch(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`),
        fields
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getMyApproval({ email }: { email: String }) {
    return api
      .get(
        getURL(
          `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000&$filter= 
          fields/eApprovedBy eq '${email.toLowerCase()}'
          or fields/eApprovedByITLead eq '${email.toLowerCase()}'
          or fields/eAssignee eq '${email.toLowerCase()}'
          `
        )
      )
      .then((res) => {
        return res.data.value.reverse();
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }
}
